import FaberApi from 'api/faber'
import OrbitApiV1 from 'api/orbitV1'
import { AxiosPromise } from 'axios'
import { NotificationGetEmailHistory } from 'types/api/faber/notification.type'

class NotificationAPI {
  /**
   * to list all notifications sent to the customer
   */
  static getEmailNotificationHistory(
    email: string,
    faberToken: string
  ): AxiosPromise<NotificationGetEmailHistory> {
    const response = FaberApi.httpGet(`/notification/email/${email}`, {
      Authorization: `Bearer ${faberToken}`
    })
    return response
  }

  static sendSubscriptionReceipt({ paymentId, faberToken }: ReceiptProps) {
    const response = FaberApi.httpPost(
      `/order/receipt`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      {
        paymentId: paymentId
      }
    )
    return response
  }

  static sendOtpackReceipt({ paymentId, faberToken }: OtpackReceiptProps) {
    const response = FaberApi.httpPost(
      `/sim/ops/plan/receipt`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      {
        paymentId: paymentId
      }
    )
    return response
  }

  static sendRefundReceipt({ paymentId, faberToken }: RefundReceiptProps) {
    const response = OrbitApiV1.httpPost(
      `/payment/stripe/refund/receipt`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      {
        paymentId: paymentId
      }
    )
    return response
  }
}

export default NotificationAPI

interface ReceiptProps {
  paymentId: string
  faberToken: string
}
interface OtpackReceiptProps {
  paymentId: string
  faberToken: string
}
interface RefundReceiptProps {
  paymentId: string
  faberToken: string
}
